export default __webpack_public_path__ + "static/media/mongodb.37c25489.svg";